import React from 'react';
import styles from './SecretPage.module.css';

const SecretPage = () => {
    const handleCoffeeClick = () => {
        alert('☕ Осторожно! Кофе-зависимость может привести к написанию чистого кода и не только!');
    };

    return (
        <div className={styles.secretPage}>
            <div className={styles.secretContainer}>
                <h1 className={styles.pageTitle}>Привет, HR! 👋</h1>

                <div className={styles.content}>
                    <div className={styles.introSection}>
                        <p>
                            Если ты это читаешь, значит моё резюме каким-то чудом прорвалось сквозь все автоматические фильтры,
                            AI-сторожей и прочие защитные механизмы, которые компании ставят против таких энтузиастов, как я.
                            Поздравляю — ты стала последним боссом перед заветной целью!
                        </p>

                        <p>
                            Знаю-знаю, у тебя там куча однообразных резюме, где все "амбициозные командные игроки с горящими глазами"
                            пытаются доказать, что они именно те самые <span className={styles.highlight}>10x developers</span>.
                            А я... я просто парень, который любит код, самоиронию и верит, что однажды его
                            <span className={styles.coffeeMention} onClick={handleCoffeeClick}>кофе</span>-зависимость превратится в нечто большее.
                        </p>
                    </div>

                    <div className={styles.card}>
                        <h2>Кто я такой? 🤔</h2>
                        <p>
                            Самоучка с огромным желанием развиваться, чувством юмора (надеюсь, это уже заметно)
                            и несколько запоздалой, но оттого не менее страстной любовью к программированию.
                        </p>
                    </div>

                    <div className={styles.card}>
                        <h2>Мой путь в IT 🛣️</h2>
                        <p>
                            Начался ещё в лицее, где я познакомился с Turbo Pascal — языком, который сейчас вызывает ностальгию у ветеранов
                            и недоумение у молодежи. Тогда я понял, что программирование — это магия, где ты из ничего создаешь что-то работающее
                            (иногда даже с первого раза!).
                        </p>

                        <p>
                            Потом была жизнь: работа, семья, прекрасные дети... И вот в один прекрасный день 2020 года
                            (или около того) я осознал, что забыл о своей мечте — писать код. Не то чтобы я совсем забыл —
                            просто отложил на "потом", которое никак не наступало.
                        </p>

                        <p>
                            Выбор пал на Python — он показался мне таким же элегантным и логичным, как когда-то Turbo Pascal.
                            С помощью прекрасного преподавателя Сергея Балакирева я освоил основы, SQL и даже написал игрушку на pygame
                            (она до сих пор висит на GitHub как памятник моим начинаниям).
                        </p>
                    </div>

                    <div className={styles.card}>
                        <h2>Мои ключевые навыки и опыт 💼</h2>
                        <ul className={styles.skillsList}>
                            <li>Python с акцентом на backend-разработку (FastAPI, Flask)</li>
                            <li>Работа с базами данных (PostgreSQL, SQLAlchemy)</li>
                            <li>Асинхронное программирование (asyncio, aiohttp)</li>
                            <li>Docker, Redis, Minio и прочие модные штуки</li>
                            <li>Небольшой, но опыт с React и JavaScript</li>
                            <li>Автоматизация процессов (ETL, скрипты, боты)</li>
                        </ul>
                    </div>

                    <div className={styles.card}>
                        <h2>Благодарности 🙏</h2>
                        <p>
                            Отдельное спасибо хочу сказать KTS студии и лично Александру Опрышко — эти ребята помогли мне определиться
                            с направлением и дали отличный пинок в сторону backend-разработки. Если вы знакомы — передайте привет!
                        </p>
                    </div>

                    <div className={styles.card}>
                        <h2>Текущая деятельность и автоматизация 🚗➡️🐍</h2>
                        <p>
                            Сейчас я работаю тренером по защитному вождению (да, вот такой поворот!) и объездил всю Россию с курсами
                            для водителей разной техники. Но однажды я понял, что кричать на водителей — не так продуктивно,
                            как заставить данные кричать на них.
                        </p>

                        <p>Так я начал автоматизировать всё, что можно:</p>

                        <h3>Мои достижения в автоматизации:</h3>
                        <ul className={styles.skillsList}>
                            <li>Скрипты на Python (Pandas, Openpyxl), превращающие сырые данные телеметрии в красивые отчеты</li>
                            <li>Дашборды со статистикой по каждому водителю и автоколонне</li>
                            <li>Telegram-бот на aiogram + RabbitMQ, моментально сообщающий о нарушениях</li>
                            <li>По сути — свой личный продакшен с ETL-процессами и асинхронностью</li>
                        </ul>
                    </div>

                    <div className={styles.card}>
                        <h2>Что я ищу? 🔍</h2>
                        <p>
                            Команду, где я смогу расти как backend-разработчик, применять свои навыки и учиться новому.
                            Где поймут моё чувство юмора и оценят самоиронию. Где кофе льется рекой,
                            а баги исправляются быстрее, чем успевают навредить.
                        </p>

                        <p>
                            У меня есть сайтик-портфолио (спросите — расскажу подробнее), где я пробую новые технологии
                            и демонстрирую свои навыки. Заходите, оценивайте — подходит ли мой мозг для ваших задач.
                        </p>
                    </div>

                    <div className={styles.closure}>
                        <p>
                            Спасибо, что дочитали до этого места! Надеюсь, мне удалось не только рассказать о себе,
                            но и немного развлечь вас — HR-специалисты тоже заслуживают хорошего настроения.
                        </p>

                        <p className={styles.highlight}>
                            Всем <span>качественного кода</span>, <span>понятных ТЗ</span> и <span>стабильного интернета</span>! 🚀
                        </p>
                    </div>

                    <div className={styles.contactPrompt}>
                        <h2>Хотите узнать больше или просто пообщаться?</h2>
                        <p>Я всегда открыт к диалогу (и предложениям о работе, конечно же 😉)</p>
                        <button
                            className={styles.contactButton}
                            onClick={() => window.location.href = '/contact'}
                        >
                            Написать мне ✍️
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default SecretPage;